import { render, staticRenderFns } from "./NonConformingProducts.vue?vue&type=template&id=31dd1964&scoped=true&"
import script from "./NonConformingProducts.vue?vue&type=script&lang=js&"
export * from "./NonConformingProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31dd1964",
  null
  
)

export default component.exports